module.exports = __webpack_public_path__ + "static/img/wing_R680.82592a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/wing_R680.jpg
// module id = mbH8
// module chunks = 0